









































































































































































import Vue from "vue";

export default Vue.extend({
  props: {
    CustomPaymentData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {};
  },
  methods: {
    getDate() {
      return {
        CustomPaymentProvider: this.CustomPaymentData.CustomPaymentProvider,
        TyroIntegratedReceipt: this.CustomPaymentData.TyroIntegratedReceipt,
        KNVPCEFTPOSServerIpAddress: this.CustomPaymentData.KNVPCEFTPOSServerIpAddress,
        KNVPCEFTPOSServerPort: this.CustomPaymentData.KNVPCEFTPOSServerPort,
        KEY_FASTPAY_DEVICE_UUID: this.CustomPaymentData.KEY_FASTPAY_DEVICE_UUID,
        KEY_CB_ALBERT_DEVICE_UUID: this.CustomPaymentData.KEY_CB_ALBERT_DEVICE_UUID,
        KNVWestPacServerManager_UserDefault_Name_StoredIPAddress: this.CustomPaymentData.KNVWestPacServerManager_UserDefault_Name_StoredIPAddress,
        KNVWestPacServerManager_UserDefault_Name_StoredSerialNumber: this.CustomPaymentData
          .KNVWestPacServerManager_UserDefault_Name_StoredSerialNumber,
        KNVWestPacServerManager_UserDefault_Name_StoredAutoAddressResolution: this.CustomPaymentData
          .KNVWestPacServerManager_UserDefault_Name_StoredAutoAddressResolution,
        posgate_host_enabled: this.CustomPaymentData.posgate_host_enabled,
        posgate_terminal_ip_address: this.CustomPaymentData.posgate_terminal_ip_address,
        posgate_terminal_ip_port: this.CustomPaymentData.posgate_terminal_ip_port,
        posgate_terminal_type: this.CustomPaymentData.posgate_terminal_type,
        KNVSmartPayServerManager_UserDefaults_POSRegisterId: this.CustomPaymentData.KNVSmartPayServerManager_UserDefaults_POSRegisterId,
        KNVSmartPayServerManager_UserDefaults_POSRegisterName: this.CustomPaymentData.KNVSmartPayServerManager_UserDefaults_POSRegisterName,
        KNVSmartPayServerManager_UserDefaults_POSBusinessName: this.CustomPaymentData.KNVSmartPayServerManager_UserDefaults_POSBusinessName,
        KNVSmartPayServerManager_UserDefaults_TerminalPairingCode: this.CustomPaymentData.KNVSmartPayServerManager_UserDefaults_TerminalPairingCode
      };
    }
  },
  watch: {}
});
